import invert from "lodash/invert";
import {CountsType} from "../../bvComponent/core/constants";
import {LayoutAbbreviation} from "../../kvComponent/core/constants";
import {getCurrentLayout} from "../../appLayout";
import Config from "../../../config";

export const getActivePartsCounts = (activePart, layoutName) => {
  let counts = 0;
  switch (document.kvConfig.visualizerType) {
    case "Bathroom":
    case "BV": {
      if (activePart.counts) {
        counts = activePart.counts.allLayoutFeaturesCount + activePart.counts[invert(CountsType)[layoutName]];
      }
      break;
    }
    case "Kitchen":
    case "KV": {
      const excluded = [
        "range", "center_island_range", "stovetop", "center_island_stovetop", "faucet", "sink", "bottom_cabinet",
        "countertop", "center_island_faucet", "center_island_sink", "center_island_countertop", "top_cabinet",
        "center_island_edge", "edge_profile"
      ];
      if (!excluded.includes(activePart.partId) && activePart.counts) {
        const layoutAbbr = LayoutAbbreviation[layoutName].toLowerCase();
        counts = activePart.counts[layoutAbbr];
      }
      break;
    }
  }
  return counts
};

export const getAvailableLayouts = () => {
  const layout = getCurrentLayout();
  const parents = layout.getFeatures();

  if (document.kvConfig.visualizerType === "bvScene") { // removed Layout4 from bvScene as it is really buggy on some profiles ("userId": 224022)
    return ["Layout1"]
  }

  return Object.keys(layout.layoutNames)
    .filter(key => key !== "All" && parents.some(parent => {
      const exisitngRelItemWithFeatures = parent.relatedItems && parent.relatedItems.find(relItem => {
        return relItem.featuresList[key] && relItem.featuresList[key].length && relItem.featuresList[key].some(feature => {
          return feature.dbFeature.s3Bindings
        })
      })
      // console.log("exisitngRelItemWithFeatures", exisitngRelItemWithFeatures);
      return exisitngRelItemWithFeatures
    }))
}

export const getShowOtherLayouts = (fabricatorSettings) => {
  if (document.kvConfig.toolVersion >= 5 && !Config.isVisualizerManagement()) {
    return false
  }
  let showOtherLayouts =
    (document.kvConfig.visualizerType === "Bathroom" || document.kvConfig.visualizerType === "BV")
      ? fabricatorSettings && (fabricatorSettings.showSmallDesignForClients
      || (fabricatorSettings.showSmallDesignFromDashboard && document.kvConfig.isBackend))
      : true;
  if (showOtherLayouts) {
    showOtherLayouts = getAvailableLayouts().length > 1
  }
  return showOtherLayouts
};

export const getAvailableRoomScenes = () => {
  let availableRoomScenes = [];
  const layout = getCurrentLayout();
  const allFeatures = layout.getAllFeatures();
  for (let i = 0; i < allFeatures.length; i++) {
    const feature = allFeatures[i];
    if (feature.dbFeature.metaData && Array.isArray(feature.dbFeature.metaData["RoomScene"])) {
      feature.dbFeature.metaData["RoomScene"].forEach(scene => {
        if (!availableRoomScenes.includes(scene)) {
          availableRoomScenes.push(scene)
        }
      })
    }
  }
  return availableRoomScenes.sort()
}

export const scrolledVerticalToTheEnd = ({clientHeight, scrollHeight, scrollTop}) => {
  const ceilScrollHeight = Math.ceil(scrollHeight);
  const floorScrollHeight = Math.floor(scrollHeight);
  const ceilScrollTop = Math.ceil(scrollTop);
  const floorScrollTop = Math.floor(scrollTop);
  const ceilClientHeight = Math.ceil(clientHeight);
  const floorClientHeight = Math.floor(clientHeight);

  return (ceilScrollHeight - ceilScrollTop === ceilClientHeight)
    || (ceilScrollHeight - floorScrollTop === ceilClientHeight)
    || (ceilScrollHeight - ceilScrollTop === floorClientHeight)
    || (ceilScrollHeight - floorScrollTop === floorClientHeight)
    || (floorScrollHeight - ceilScrollTop === ceilClientHeight)
    || (floorScrollHeight - floorScrollTop === ceilClientHeight)
    || (floorScrollHeight - floorScrollTop === floorClientHeight)
    || (floorScrollHeight - floorScrollTop === floorClientHeight)
}

/**
 * when the new customer is created - the system creates a job for him with only one userState property
 * @param parentGroup {object}
 // * @param fabricatorData {object}
 * @returns {array}
 */
export const getSideBarSubParts = (parentGroup) => {
  if (!parentGroup || !parentGroup.subParts || !parentGroup.layout) {
    return []
  }
  let subParts = parentGroup.subParts(true, true) || [];
  const layout = parentGroup.layout;
  if (!Config.showAllVisualizerGroups()) {
    subParts = subParts.filter(subPart => {
      return layout.hasNavItemsLength(subPart)
        // && !(fabricatorData && fabricatorData.isEncore && Array.isArray(layout.disabledClickablePartIds)
        //   && layout.disabledClickablePartIds.includes(subPart.part.partId)) // hide if it's not clickable (for encore)
    })
  }
  return subParts
}
